export const MAP_DEFAULT_OPTIONS = {
  MAP_VIEW_URL: 'mapbox://styles/mapbox/',
  STREET_VIEW: 'streets-v11',
  SATELLITE_VIEW: 'satellite-v9',
  SATELLITE_STREET_VIEW: 'satellite-streets-v11',
  ZOOM: 16,
  LNG_LAT_FIX: 5,
  ZOOM_FIX: 2,
  DIRECTION_API: 'https://api.mapbox.com/directions/v5/mapbox',
  GEOCODING_API: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
}
